export default "__VITE_ASSET__CaPkl8I4__"